import clsx from 'clsx';

export function Spinner({
  className,
  color = 'black',
  stroke = 2
}: {
  className?: string;
  color?: 'black' | 'white';
  stroke?: 2 | 3 | 4;
}) {
  return (
    <div
      className={clsx(
        'animate-spin after:absolute after:inset-0 after:origin-center after:rounded-full motion-reduce:animate-none',
        color === 'black'
          ? 'after:border-black/10 after:border-t-black/35'
          : 'after:border-white/15 after:border-t-white/45',
        stroke === 2 && 'after:border-2',
        stroke === 3 && 'after:border-3',
        stroke === 4 && 'after:border-4',
        className
      )}
    />
  );
}
